import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Button } from "@chakra-ui/button";
import { Link } from "react-router-dom";

function App() {
  return (
    <div className="App" style={{position: "relative"}}>
      <Link to="/support" style={{position: "absolute", top: 10, left: 10}}><Button>Keep in touch</Button></Link>
      <img src="/robot.png" />
    </div>
  );
}

export default App;
